import Wad from 'web-audio-daw';

export enum AUDIO {
  AMBIENT = 'ambient',
  PAYOUT = 'payout',
  CASCADE = 'cascade',
  PRESS = 'press',
  WIN_LINE = 'win_line',
  REEL_END = 'reel_end',
  REEL_DROP = 'reel_drop',
  REEL_CASCADE = 'reel_cascade',
  PRIZE = 'prize',
  ACCEPTED = 'accepted',
  TRASH = 'trash',
  CHAT_RECEIVED = 'ios_whatsapp_message',
  PENDING = 'short-email',
  MESSAGE = 'whatsapp_message',
  DRAW_EVALUATED = 'draw_evaluated',
  LUCKY_CELLS_APP = 'lucky_cells_app',
  CLICK_SHORT = 'click_short',
}
export interface IAudio {
  wad?;
  volume: number;
  name: AUDIO;
  source: string;
  apps: string[];
  state: WAD_STATE;
}
export enum AUDIO_ACTIONS {
  PLAY = 'PLAY',
  PAUSE = 'PAUSE',
}
export interface IAudioActions {
  name: AUDIO;
  action: AUDIO_ACTIONS;
}
export enum WAD_STATE {
  PLAYING = 'playing',
  STOPPED = 'stopped',
}
